<template>
    <span id="login-change" class="dropdown__wrapper">
        <span class="dropdown"
              v-if="isLoggedIn">
            <a href="#"
               class="dropdown-toggle shop-nav__btn"
               id="accountMenuList"
               data-toggle="dropdown"
               aria-haspopup="true"
               aria-expanded="false">
                <i class="icon__user" aria-hidden="true"></i>
            </a>
            <span class="dropdown-menu dropdown-menu-right">
                <span class="user-login__cta-wrapper"
                      aria-labelledby="accountMenuList">
                    <span class="user-login__name">
                        {{ $translate("ODNaPo::NaPo.loginMyAccountWelcome") }}&nbsp;{{ username }}{{ $translate("ODNaPo::NaPo.loginMyAccountWelcomeEM") }}
                    </span>
                    <a href="#"
                       class="user-login__cta user-login__cta--logout"
                       v-logout>
                        {{ $translate("Ceres::Template.loginLogout") }}
                    </a>
                    <span class="user-login__sepperator"></span>
                    <a :href="$ceres.urls.myAccount"
                       class="user-login__cta user-login__cta--block">
                        {{ $translate("Ceres::Template.loginMyAccount") }}
                    </a>
                    <a :href="$ceres.urls.myAccount"
                       class="user-login__cta user-login__cta--block">
                        {{ $translate("ODNaPo::NaPo.loginMyAccountOrders") }}
                    </a>
                    <!-- <a :href="$ceres.urls.myAccount"
                       class="user-login__cta user-login__cta--block">
                        {{ $translate("ODNaPo::NaPo.loginMyAccountRetoure") }}
                    </a> -->
                    <a :href="$ceres.urls.myAccount"
                       class="user-login__cta user-login__cta--block">
                        {{ $translate("ODNaPo::NaPo.loginMyAccountHelp") }}
                    </a>
                </span>
                <span class="user-login__close"
                      v-close-dropdown>
                    <svg width="20" height="20">
                        <use xmlns:xlink="http://www.w3.org/1999/xlink"
                             xlink:href="#svg-close">
                        </use>
                    </svg>
                </span>
            </span>
        </span>

        <span class="dropdown"
              v-if="!isLoggedIn">
            <a href="#"
               class="dropdown-toggle shop-nav__btn"
               id="accountMenuListTwo"
               data-toggle="dropdown"
               aria-haspopup="true"
               aria-expanded="false">
                <i class="icon__user" aria-hidden="true"></i>
            </a>
            <span class="dropdown-menu dropdown-menu-right">
                <span class="user-login__cta-wrapper"
                      aria-labelledby="accountMenuListTwo">
                    <a data-toggle="modal"
                       data-target="#id--login-modal"
                       href="javascript:void(0)"
                       class="user-login__cta user-login__cta--pipe"
                       @click="createLoginModal(); unmarkInputFields()">
                        <span>
                            {{ $translate("Ceres::Template.login") }}
                        </span>
                    </a>
                    <a :href="isLogin ? 'javascript:void(0)' : $ceres.urls.registration"
                       class="user-login__cta">
                        <span>
                            {{ $translate("Ceres::Template.loginRegister") }}
                        </span>
                    </a>
                    <span class="user-login__sepperator"></span>
                    <a :href="$ceres.urls.myAccount"
                       class="user-login__cta user-login__cta--block">
                        {{ $translate("Ceres::Template.loginMyAccount") }}
                    </a>
                    <a :href="$ceres.urls.myAccount"
                       class="user-login__cta user-login__cta--block">
                        {{ $translate("ODNaPo::NaPo.loginMyAccountOrders") }}
                    </a>
                    <!-- <a :href="$ceres.urls.myAccount"
                       class="user-login__cta user-login__cta--block">
                        {{ $translate("ODNaPo::NaPo.loginMyAccountRetoure") }}
                    </a> -->
                    <a :href="$ceres.urls.myAccount"
                       class="user-login__cta user-login__cta--block">
                        {{ $translate("ODNaPo::NaPo.loginMyAccountHelp") }}
                    </a>
                </span>
                <span class="user-login__close"
                      v-close-dropdown>
                    <svg width="20" height="20">
                        <use xmlns:xlink="http://www.w3.org/1999/xlink"
                             xlink:href="#svg-close">
                        </use>
                    </svg>
                </span>
            </span>
        </span>

    </span>
</template>

<script>
import ApiService from "ceres/app/services/ApiService";
import ValidationService from "ceres/app/services/ValidationService";
import { isDefined } from "ceres/app/helper/utils";
import { mapGetters, mapActions } from "vuex";

export default {
    props: {
        showRegistration: {
            type: Boolean,
            default: true
        },
        showLogin: {
            type: Boolean,
            default: true
        }
    },

    computed: {
        ...mapGetters([
           "username",
           "isLoggedIn"
        ])
    },

    data()
    {
        return {
            isLogin: App.templateType === "login",
            isRegister: App.templateType === "register"
        };
    },

    created()
    {
        ApiService.get("/rest/io/customer", {}, { keepOriginalResponse: true })
            .done(response =>
            {
                if (isDefined(response.data))
                {
                    this.$store.commit("setUserData", response.data);
                }
            });

        this.isLogin = App.templateType === "login";
        this.isRegister = App.templateType === "register";
    },

    /**
     * Add the global event listener for login and logout
     */
    mounted()
    {
        this.$nextTick(() =>
        {
            this.addEventListeners();
        });
    },

    methods: {
        /**
         * Adds login/logout event listeners
         */
        addEventListeners()
        {
            ApiService.listen("AfterAccountAuthentication", userData =>
            {
                this.$store.commit("setUserData", userData.accountContact);
            });

            ApiService.listen("AfterAccountContactLogout", () =>
            {
                this.$store.commit("setUserData", null);
            });
        },

        unmarkInputFields()
        {
            ValidationService.unmarkAllFields($("#login"));
            ValidationService.unmarkAllFields($("#registration"));
        },

        createLoginModal()
        {
            this.loadComponent("login-modal");

        },

        createRegisterModal()
        {
            this.loadComponent("register-modal");
        },

        ...mapActions([
            "loadComponent"
        ])
    }
}
</script>
